import { useEffect, useState } from 'react';

/**
 * A monotonically-increasing `fetchKey` that ticks every `intervalMs` while
 * `active`, and stops (holding its value) when idle. Feed it to `useLazyLoadQuery`
 * as `{ fetchKey, fetchPolicy: 'store-and-network' }` to poll a query on an
 * interval — the crawl screens poll while any run is `Queued`/`Running` and go
 * quiet once every run is terminal. Apis.Admin has no GraphQL subscriptions, so
 * this interval refetch is the live-update mechanism.
 */
export function usePollingFetchKey(active: boolean, intervalMs = 5000): number {
    const [key, setKey] = useState(0);

    useEffect(() => {
        if (!active) return;
        const id = setInterval(() => setKey((current) => current + 1), intervalMs);
        return () => clearInterval(id);
    }, [active, intervalMs]);

    return key;
}
